import {
  FETCH_DOCUMENT_USERS,
  FETCH_DOCUMENT_USERS_SUCCESS,
  FETCH_DOCUMENT_USERS_FAILED,
  UPDATE_DOCUMENT_USERS,
} from '../store/types';

const initialState = {
  data: [],
  loading: false,
  error: null
};

export const documentUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENT_USERS:
      return {
        ...state,
        loading: true
      };
    case FETCH_DOCUMENT_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case UPDATE_DOCUMENT_USERS:
      return state;
    case FETCH_DOCUMENT_USERS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default documentUsersReducer; 